export const FLASHCARDS = [
    {
       "id":1,
       "topic_id":100,
       "title":"Which NTP command configures the local device as an NTP reference clock source?",
       "desc":"<code>ntp master</code>"
    },
    {
       "id":2,
       "topic_id":100,
       "title":"What is the subnet and broadcast address of this host: 10.16.3.65/23?",
       "desc":"10.16.2.0 255.255.254.0, 10.16.3.255 255.255.254.0"
    },
    {
       "id":3,
       "topic_id":100,
       "title":"Under which circumstance should a network administrator implement one-way NAT?",
       "desc":"When the network has few public IP addresses, and many private IP addresses require outside Internet access"
    },
    {
       "id":4,
       "topic_id":100,
       "title":"True/False. When configuring static routes, an exit interface can be specified to indicate where the packets will be routed.",
       "desc":"TRUE"
    },
    {
       "id":5,
       "topic_id":100,
       "title":"Which device allows users to connect to the network using a single or double radio?",
       "desc":"Access point"
    },
    {
       "id":6,
       "topic_id":100,
       "title":"Which method does a connected trunk port use to tag VLAN traffic?",
       "desc":"IEEE 802.1Q"
    },
    {
       "id":7,
       "topic_id":100,
       "title":"True/False. This is a valid hostname for a switch following Cisco\u0027s guidelines: 5witch-Cisco.",
       "desc":"False"
    },
    {
       "id":8,
       "topic_id":100,
       "title":"Which function enables an administrator to route multiple VLANs on a router?",
       "desc":"Router on a stick"
    },
    {
       "id":9,
       "topic_id":100,
       "title":"True/False. Routers perform this on a packet: Update the layer 3 headers of outbound packets so that the packets are properly directed to their ultimate destinations.",
       "desc":"False. They update the layer 2 headers of outbound packets with the MAC addresses of the next hop."
    },
    {
       "id":10,
       "topic_id":100,
       "title":"True/False. Routers perform this on a packet: Examine the layer 3 headers of inbound packets and use that information to determine the next hops for the packets.",
       "desc":"TRUE"
    },
    {
       "id":11,
       "topic_id":100,
       "title":"A workstation has just resolved a browser URL to the IP address of a server. Which protocol will the workstation now use to determine the MAC address to be placed into frames directed toward the server?",
       "desc":"ARP"
    },
    {
       "id":12,
       "topic_id":100,
       "title":"Which RFC was created to alleviate the depletion of IPv4 public addresses?",
       "desc":1918
    },
    {
       "id":13,
       "topic_id":100,
       "title":"Configuration of which option is required on a Cisco switch for the Cisco IP phone to work?",
       "desc":"A voice VLAN ID in interface and global configuration mode"
    },
    {
       "id":14,
       "topic_id":100,
       "title":"At which layer of the OSI model does the protocol that provides the information that is displayed by the <code>show cdp neighbors</code> command operate?",
       "desc":"Data Link"
    },
    {
       "id":15,
       "topic_id":100,
       "title":"Two hosts are attached to a switch with the default configuration. How many broadcasts are there?",
       "desc":"One"
    },
    {
       "id":16,
       "topic_id":100,
       "title":"On which type of device is every port in the same collision domain?",
       "desc":"A hub"
    },
    {
       "id":17,
       "topic_id":100,
       "title":"What is the default lease title for a DHCP binding?",
       "desc":"24 hours"
    },
    {
       "id":18,
       "topic_id":100,
       "title":"Which MTU size can cause a baby giant error?",
       "desc":"1600 bytes"
    },
    {
       "id":19,
       "topic_id":100,
       "title":"True/False. Tracert uses ICMP packets.",
       "desc":"TRUE"
    },
    {
       "id":20,
       "topic_id":100,
       "title":"Which route source code represents the routing protocol with a default administrative distance of 90 in the routing table?",
       "desc":"D"
    },
    {
       "id":21,
       "topic_id":100,
       "title":"Which component of the routing table ranks routing protocols according to their preferences?",
       "desc":"Administrative distance"
    },
    {
       "id":22,
       "topic_id":100,
       "title":"Which component of a routing table entry represents the subnet mask?",
       "desc":"Prefix"
    },
    {
       "id":23,
       "topic_id":100,
       "title":"Which value is indicated by the next hop in a routing table?",
       "desc":"IP address of the remote router for forwarding the packets"
    },
    {
       "id":24,
       "topic_id":100,
       "title":"Which dynamic routing protocol uses only the hop count to determine the best path to a destination?",
       "desc":"RIP"
    },
    {
       "id":25,
       "topic_id":100,
       "title":"Which feature allows a device to use a switch port that is configured for half-duplex to access the network?",
       "desc":"CSMA/CD"
    },
    {
       "id":26,
       "topic_id":100,
       "title":"A transmitting host MAC address is not in the MAC table of a switch. What will the switch will do when it receives the frame from the host?",
       "desc":"The switch will add the source address and port to the MAC address table and forward the frame to the destination host if known; if not, it will flood the frame."
    },
    {
       "id":27,
       "topic_id":100,
       "title":"What is one requirement for interfaces to run IPv6?",
       "desc":"An IPv6 address must be configured on the interface."
    },
    {
       "id":28,
       "topic_id":100,
       "title":"Which routing protocol has the default administrative distance of 90?",
       "desc":"EIGRP"
    },
    {
       "id":29,
       "topic_id":100,
       "title":"Which technology supports the stateless assignment of IPv6 addresses?",
       "desc":"Auto configuration"
    },
    {
       "id":30,
       "topic_id":100,
       "title":"By default, how many MAC addresses are permitted to be learned on a switch port with port security enabled?",
       "desc":1
    },
    {
       "id":31,
       "topic_id":100,
       "title":"Which NAT type is used to translate a single inside address to a single outside address?",
       "desc":"Static NAT"
    },
    {
       "id":32,
       "topic_id":100,
       "title":"True/False. Cisco Discovery Protocol traffic travels on the native VLAN by default.",
       "desc":"TRUE"
    },
    {
       "id":33,
       "topic_id":100,
       "title":"Which address type does a switch use to make selective forwarding decisions?",
       "desc":"Destination MAC address"
    },
    {
       "id":34,
       "topic_id":100,
       "title":"True/False. TCP provides sequence numbering of packets.",
       "desc":"TRUE"
    },
    {
       "id":35,
       "topic_id":100,
       "title":"True/False. TCP provides synchronized communication.",
       "desc":"TRUE"
    },
    {
       "id":36,
       "topic_id":100,
       "title":"On a Cisco switch, which protocol determines if an attached VoIP phone is from Cisco or from another vendor?",
       "desc":"CDP"
    },
    {
       "id":37,
       "topic_id":100,
       "title":"Which destination IP address can a host use to send one message to multiple devices across different subnets?",
       "desc":"A multicast address. Range is 224.0.0.0 through 239.255.255.255."
    },
    {
       "id":38,
       "topic_id":100,
       "title":"When enabled, which feature prevents routing protocols from sending hello messages on an interface?",
       "desc":"<code>Passive-interface</code> Or you can <code>shutdown</code> the port"
    },
    {
       "id":39,
       "topic_id":100,
       "title":"True/False. WLC\u0027s Gold queue is also known as the video queue.",
       "desc":"TRUE"
    },
    {
       "id":40,
       "topic_id":100,
       "title":"Which option must occur before a workstation can exchange HTTP packets with a web server?",
       "desc":"A TCP connection must be established between the workstation and the web server."
    },
    {
       "id":41,
       "topic_id":100,
       "title":"True/False. If the destination MAC address is unknown, the frame is flooded to every port that is in the same VLAN, except the port it was received on.",
       "desc":"TRUE"
    },
    {
       "id":42,
       "topic_id":100,
       "title":"When a router makes a routing decision for a packet that is received from one network and destined to another, which portion of the packet is replaced?",
       "desc":"Layer 2 frame header and trailer"
    },
    {
       "id":43,
       "topic_id":100,
       "title":"Which network topology allows all traffic to flow through a central hub?",
       "desc":"Star"
    },
    {
       "id":44,
       "topic_id":100,
       "title":"True/False. OSPF is a link-state routing protocol.",
       "desc":"TRUE"
    },
    {
       "id":45,
       "topic_id":100,
       "title":"True/False. RIP is a link-state routing protocol.",
       "desc":"FALSE"
    },
    {
       "id":46,
       "topic_id":100,
       "title":"Which two states are the port states when RSTP has converged?",
       "desc":"Discarding, forwarding"
    },
    {
       "id":47,
       "topic_id":100,
       "title":"WLANs default to the _______ queue, which effectively means no QoS is being utilized.",
       "desc":"Silver"
    },
    {
       "id":48,
       "topic_id":100,
       "title":"Which Cisco platform can verify ACLs?",
       "desc":"Cisco APIC-EM"
    },
    {
       "id":49,
       "topic_id":100,
       "title":"Which type of switch ports drop packets with 802.1Q tags?",
       "desc":"Access ports"
    },
    {
       "id":50,
       "topic_id":100,
       "title":"You enter the <code>show ipv6 route</code> command on a router and the device displays a route. What routing protocol is used?",
       "desc":"OSPFv3"
    },
    {
       "id":51,
       "topic_id":100,
       "title":"Which switch states are valid for 802.1w?",
       "desc":"Discarding, learning, forwarding"
    },
    {
       "id":52,
       "topic_id":100,
       "title":"What can cause collision domain issues on VLAN domain?",
       "desc":"Congestion on the switch in band path, BS duplex mismatches on Ethernet segments in the same VLAN"
    },
    {
       "id":53,
       "topic_id":100,
       "title":"What is a benefit of switch stacking?",
       "desc":"It provides higher port density with better resource usage."
    },
    {
       "id":54,
       "topic_id":100,
       "title":"What protocol supports sharing the VLAN configuration between two or more switches?",
       "desc":"VTP"
    },
    {
       "id":55,
       "topic_id":100,
       "title":"Which part of the PPPoE server configurator contains the information used to assign an IP address to a PPPoE client?",
       "desc":"Virtual Template Interface"
    },
    {
       "id":56,
       "topic_id":100,
       "title":"What process is associated with spanning-tree convergence?",
       "desc":"Electing designated ports"
    },
    {
       "id":57,
       "topic_id":100,
       "title":"Which type of interface can negotiate an IP address for a PPPoE client?",
       "desc":"Dialer"
    },
    {
       "id":58,
       "topic_id":100,
       "title":"What is the purpose of traffic policing?",
       "desc":"It drops traffic that exceeds the CIR."
    },
    {
       "id":59,
       "topic_id":100,
       "title":"Which IEEE standard does PVST+ use to tunnel information?",
       "desc":"802.1q"
    },
    {
       "id":60,
       "topic_id":100,
       "title":"Which version of SNMP first allowed user-based access?",
       "desc":"SNMPv1"
    },
    {
       "id":61,
       "topic_id":100,
       "title":"What are two drawbacks of implementing a link-state routing protocol?",
       "desc":"The requirement for a hierarchical IP addressing scheme for optimal functionality, and high demand on router resources to run the link-state routing algorithm"
    },
    {
       "id":62,
       "topic_id":100,
       "title":"What is a difference between TACACS+ and RADIUS in AAA?",
       "desc":"Only TACACS+ allows for separate authentication."
    },
    {
       "id":63,
       "topic_id":100,
       "title":"What is the default VLAN on an access port?",
       "desc":"VLAN 1"
    },
    {
       "id":64,
       "topic_id":100,
       "title":"True/False. IP SLAs are used to determine the frequency of ICMP packets.",
       "desc":"TRUE"
    },
    {
       "id":65,
       "topic_id":100,
       "title":"What is a valid HSRP virtual MAC address?",
       "desc":"Look for the 07.AC in the address, such as: 0000.0C<strong>07.AC</strong>15."
    },
    {
       "id":66,
       "topic_id":100,
       "title":"Which feature can you use to monitor traffic on a switch by replicating it to another port or ports on the same switch?",
       "desc":"SPAN"
    },
    {
       "id":67,
       "topic_id":100,
       "title":"True/False. Video traffic is passed with a well-known DSCP value of 46.",
       "desc":"TRUE"
    },
    {
       "id":68,
       "topic_id":100,
       "title":"What are two enhancements that OSPFv3 supports over OSPFv2?",
       "desc":"It can support multiple IPv6 subnets on a single link, and it routes over links rather than over networks."
    },
    {
       "id":69,
       "topic_id":100,
       "title":"Which protocol authenticates connected devices before allowing them to access the LAN?",
       "desc":"802 .1x"
    },
    {
       "id":70,
       "topic_id":100,
       "title":"Describe slow inter-VLAN forwarding.",
       "desc":"The local VLAN is working normally, but traffic to the alternate VLAN is forwarded more slowly than expected."
    },
    {
       "id":71,
       "topic_id":100,
       "title":"True/False. Intelligent DNS can redirect user requests to locations that are using fewer network resources.",
       "desc":"TRUE"
    },
    {
       "id":72,
       "topic_id":100,
       "title":"What configuration must you apply to enable encapsulation on a subinterface?",
       "desc":"Answer Example (can use any numbers from 1–4094): <br><code>interface FastEthernet 0/0.30</code> <br><code>encapsulation dotlQ 30</code><br><code>ip address 10.1.1.30 255.255.255.0</code>"
    },
    {
       "id":73,
       "topic_id":100,
       "title":"True/False.  When a switch in rapid PVST+ mode has a topology change, the switch immediately deletes dynamic MAC addresses that were learned by all ports on the switch.",
       "desc":"False. It deletes all MAC addresses in that one VLAN instance."
    },
    {
       "id":74,
       "topic_id":100,
       "title":"True/False. Named ACLs support only extended ACLs.",
       "desc":"FALSE"
    },
    {
       "id":75,
       "topic_id":100,
       "title":"How can you disable DTP on a switch port?",
       "desc":"Change the operational mode to static access."
    },
    {
       "id":76,
       "topic_id":100,
       "title":"Which identification numbers are valid for an extended ACL?",
       "desc":"100–199"
    },
    {
       "id":77,
       "topic_id":100,
       "title":"You executed the <code>show interface port-channel 1 ether channel</code> command. What information is provided by the Load value? <img src='/question_assets/24/image1.png'></img>",
       "desc":"The preference of the link"
    },
    {
       "id":78,
       "topic_id":100,
       "title":"True/False. DTP uses the native VLAN to send data.",
       "desc":"TRUE"
    },
    {
       "id":79,
       "topic_id":100,
       "title":"Which spanning-tree feature places a port immediately into a forwarding state?",
       "desc":"PortFast"
    },
    {
       "id":80,
       "topic_id":100,
       "title":"Which type of topology is required by DMVPN?",
       "desc":"Hub and spoke"
    },
    {
       "id":81,
       "topic_id":100,
       "title":"Which component of the Cisco SDN solution serves as the centralized management system?",
       "desc":"Cisco APIC"
    },
    {
       "id":82,
       "topic_id":100,
       "title":"MPLS operates at what layer?",
       "desc":"It operates between layer 2 and layer 3"
    },
    {
       "id":83,
       "topic_id":100,
       "title":"What is the best way to verify that a host has a path to other hosts in different networks?",
       "desc":"Ping the default gateway."
    },
    {
       "id":84,
       "topic_id":100,
       "title":"Which EIGRP for IPv6 command can you enter to view the link-local addresses of the neighbors of a device?",
       "desc":"<code>show ipv6 eigrp neighbors</code>"
    },
    {
       "id":85,
       "topic_id":100,
       "title":"What is the first step you perform to configure an SNMPv3 user?",
       "desc":"Configure the server group."
    },
    {
       "id":86,
       "topic_id":100,
       "title":"True/False. EIGRPv6 needs a RID under the routing process.",
       "desc":"TRUE"
    },
    {
       "id":87,
       "topic_id":200,
       "title":"Differentiate between a Switch and a Router",
       "desc":"Switches operate at layer 2 of the OSI model and only read frame hardware addresses in a frame to make a switching decision. Routers read to layer 3 and use routed (logical) address to make forwarding decision on a packet"
    },
    {
       "id":88,
       "topic_id":200,
       "title":"Understand the term SOHO",
       "desc":"SOHO means small office, home office, and is small network connecting a user or small handful of users to the internet and office resources such as servers and printers. Usually just one router and a switch or two, plus a firewall."
    },
    {
       "id":89,
       "topic_id":200,
       "title":"Define 3-Tier Architecture",
       "desc":"The Cisco hierarchical model can help you design, implement, and maintain a scalable, reliable, cost-effective hierarchical internetwork. Cisco defines three layers of hierarchy, the core, distribution, and access, each with specific functions, and it\u0027s referred to as a 3-tier network architecture."
    },
    {
       "id":90,
       "topic_id":200,
       "title":"Define 2-Tier Acthitecture",
       "desc":"2-tier architecture is also referred to as the collapsed core design because it\u0027s only 2-layers. But in concept, it\u0027s like the 3-tier only less expensive and geared for smaller companies. The design is meant to maximize performance and user availability to the network, while still allowing for design scalability over time. In a 2-tier, the distribution layer is merged with the core layer."
    },
    {
       "id":91,
       "topic_id":200,
       "title":"Define spine-leaf",
       "desc":"Also referred to as leaf-and-spine topology, in the leaf-and-spine design, there are switches found at the top of each rack that connect to the servers in the rack, with a server connecting into each switch for redundancy. People refer to this as a top-of-rack (ToR) design because the switches physically reside at the top of a rack."
    },
    {
       "id":92,
       "topic_id":200,
       "title":"Differentiate between the DoD and the OSI network models.",
       "desc":"The DoD model is a condensed version of the OSI model, composed of four layers instead of seven, but is nonetheless like the OSI model in that it can be used to describe packet creation and devices and protocols can be mapped to its layers."
    },
    {
       "id":93,
       "topic_id":200,
       "title":"Identify Host-to-Host layer protocols.",
       "desc":"Transmission Control Protocol (TCP) is a connectionoriented protocol that provides reliable network service by using acknowledgments and flow control. User Datagram Protocol (UDP) is a connectionless protocol that provides low overhead and is considered unreliable."
    },
    {
       "id":94,
       "topic_id":200,
       "title":"Identify Internet layer protocols.",
       "desc":"Internet Protocol (IP) is a connectionless protocol that provides network address and routing through an internetwork. Address Resolution Protocol (ARP) finds a hardware address from a known IP address. Reverse ARP (RARP) finds an IP address from a known hardware address. Internet Control Message Protocol (ICMP) provides diagnostics and destination unreachable messages."
    },
    {
       "id":95,
       "topic_id":200,
       "title":"Describe the functions of DNS and DHCP in the network.",
       "desc":"Dynamic Host Configuration Protocol (DHCP) provides network configuration information (including IP addresses) to hosts, eliminating the need to perform the configurations manually. Domain Name Service (DNS) resolves hostnames—both Internet names such as www.lammle.com and device names such as Workstation 2—to IP addresses, eliminating the need to know the IP address of a device for connection purposes."
    },
    {
       "id":96,
       "topic_id":200,
       "title":"Identify what is contained in the TCP header of a connection-oriented transmission.",
       "desc":"The fields in the TCP header include the source port, destination port, sequence number, acknowledgment number, header length, a field reserved for future use, code bits, window size, checksum, urgent pointer, options field, and finally, the data field."
    },
    {
       "id":97,
       "topic_id":200,
       "title":"Identify what is contained in the UDP header of a connectionless transmission.",
       "desc":"The fields in the UDP header include only the source port, destination port, length, checksum, and data. The smaller number of fields as compared to the TCP header comes at the expense of providing none of the more advanced functions of the TCP frame."
    },
    {
       "id":98,
       "topic_id":200,
       "title":"Identify what is contained in the IP header.",
       "desc":"The fields of an IP header include version, header length, priority or type of service, total length, identification, flags, fragment offset, time to live, protocol, header checksum, source IP address, destination IP address, options, and finally, data."
    },
    {
       "id":99,
       "topic_id":200,
       "title":"Compare and contrast UDP and TCP characteristics and features.",
       "desc":"TCP is connectionoriented, acknowledged, and sequenced and has flow and error control, while UDP is connectionless, unacknowledged, and not sequenced and provides no error or flow control."
    },
    {
       "id":100,
       "topic_id":200,
       "title":"Understand the role of port numbers.",
       "desc":"Port numbers are used to identify the protocol or service that is to be used in the transmission."
    },
    {
       "id":101,
       "topic_id":200,
       "title":"Identify the role of ICMP.",
       "desc":"Internet Control Message Protocol (ICMP) works at the Network layer and is used by IP for many different services. ICMP is a management protocol and messaging service provider for IP."
    },
    {
       "id":102,
       "topic_id":200,
       "title":"Define the Class A IP address range.",
       "desc":"The IP range for a Class A network is 1–126. This provides 8 bits of network addressing and 24 bits of host addressing by default."
    },
    {
       "id":103,
       "topic_id":200,
       "title":"Define the Class B IP address range.",
       "desc":"The IP range for a Class B network is 128–191. Class B addressing provides 16 bits of network addressing and 16 bits of host addressing by default."
    },
    {
       "id":104,
       "topic_id":200,
       "title":"Define the Class C IP address range.",
       "desc":"The IP range for a Class C network is 192 through 223. Class C addressing provides 24 bits of network addressing and 8 bits of host addressing by default."
    },
    {
       "id":105,
       "topic_id":200,
       "title":"Identify the private IP ranges.",
       "desc":"The Class A private address range is 10.0.0.0 through 10.255.255.255. The Class B private address range is 172.16.0.0 through 172.31.255.255. The Class C private address range is 192.168.0.0 through 192.168.255.255."
    },
    {
       "id":106,
       "topic_id":200,
       "title":"Understand the difference between a broadcast, unicast, and multicast address.",
       "desc":"A broadcast is to all devices in a subnet, a unicast is to one device, and a multicast is to some but not all devices."
    },
    {
       "id":107,
       "topic_id":200,
       "title":"Identify the advantages of subnetting.",
       "desc":"Benefits of subnetting a physical network include reduced network traffic, optimized network performance, simplified management, and facilitated spanning of large geographical distances."
    },
    {
       "id":108,
       "topic_id":200,
       "title":"Describe the effect of the ip subnet-zero command.",
       "desc":"This command allows you to use the first and last subnet in your network design."
    },
    {
       "id":109,
       "topic_id":200,
       "title":"Identify the steps to subnet a classful network.",
       "desc":"Understand how IP addressing and subnetting work. First, determine your block size by using the 256-subnet mask math. Then count your subnets and determine the broadcast address of each subnet—it is always the number right before the next subnet. Your valid hosts are the numbers between the subnet address and the broadcast address."
    },
    {
       "id":110,
       "topic_id":200,
       "title":"Determine possible block sizes.",
       "desc":"This is an important part of understanding IP addressing and subnetting. The valid block sizes are always 2, 4, 8, 16, 32, 64, 128, etc. You can determine your block size by using the 256-subnet mask math."
    },
    {
       "id":111,
       "topic_id":200,
       "title":"Describe the role of a subnet mask in IP addressing.",
       "desc":"A subnet mask is a 32-bit value that allows the recipient of IP packets to distinguish the network ID portion of the IP address from the host ID portion of the IP address."
    },
    {
       "id":112,
       "topic_id":200,
       "title":"Describe the benefits of variable length subnet masks (VLSMs).",
       "desc":"VLSMs enable the creation of subnets of specific sizes and allow the division of a classless network into smaller networks that do not need to be equal in size. This makes use of the address space more efficient because many times IP addresses are wasted with classful subnetting."
    },
    {
       "id":113,
       "topic_id":200,
       "title":"Understand the relationship between the subnet mask value and the resulting block size and the allowable IP addresses in each resulting subnet.",
       "desc":"The relationship between the classful network being subdivided and the subnet mask used determines the number of possible hosts or the block size. It also determines where each subnet begins and ends and which IP addresses cannot be assigned to a host within each subnet."
    },
    {
       "id":114,
       "topic_id":200,
       "title":"Describe the process of summarization or route aggregation and its relationship to subnetting.",
       "desc":"Summarization is the combining of subnets derived from a classful network for the purpose of advertising a single route to neighboring routers instead of multiple routes, reducing the size of routing tables and speeding the route process."
    },
    {
       "id":115,
       "topic_id":200,
       "title":"Calculate the summary mask that will advertise a single network representing all subnets.",
       "desc":"The network address used to advertise the summary address is always the first network address in the block of subnets. The mask is the subnet mask value that yields the same block size."
    },
    {
       "id":116,
       "topic_id":200,
       "title":"Remember the four diagnostic steps.",
       "desc":"The four simple steps that Cisco recommends for troubleshooting are ping the loopback address, ping the NIC, ping the default gateway, and ping the remote device."
    },
    {
       "id":117,
       "topic_id":200,
       "title":"Identify and mitigate an IP addressing problem.",
       "desc":"Once you go through the four troubleshooting steps that Cisco recommends, you must be able to determine the IP addressing problem by drawing out the network and finding the valid and invalid hosts addressed in your network."
    },
    {
       "id":118,
       "topic_id":200,
       "title":"Understand the troubleshooting tools that you can use from your host and a Cisco router.",
       "desc":"The ping 127.0.0.1 command tests your local IP stack, and tracert is a Windows command to track the path a packet takes through an internetwork to a destination. Cisco routers use the command traceroute, or just trace for short. Don\u0027t confuse the Windows and Cisco commands. Although they produce the same output, they don\u0027t work from the same prompts. The command ipconfig /all will display your PC network configuration from a DOS prompt, and arp -a (again from a DOS prompt) will display IP-to-MAC-address mapping on a Windows PC."
    },
    {
       "id":119,
       "topic_id":200,
       "title":"Describe the basic IP routing process.",
       "desc":"You need to remember that the layer-2 frame changes at each hop but that the packet is never changed or manipulated in any way until it reaches the destination device (the TTL field in the IP header is decremented for each hop, but that\u0027s it!)."
    },
    {
       "id":120,
       "topic_id":200,
       "title":"List the information required by a router to successfully route packets.",
       "desc":"To be able to route packets, a router must know, at a minimum, the destination address, the location of neighboring routers through which it can reach remote networks, possible routes to all remote networks, the best route to each remote network, and how to maintain and verify routing information."
    },
    {
       "id":121,
       "topic_id":200,
       "title":"Describe how MAC addresses are used during the routing process.",
       "desc":"A MAC (hardware) address will only be used on a local LAN. It will never pass a router\u0027s interface. A frame uses MAC (hardware) addresses to send a packet on a LAN. The frame will take the packet to either a host on the LAN or a router\u0027s interface (if the packet is destined for a remote network). As packets move from one router to another, the MAC addresses used will change, but normally the original source and destination IP addresses within the packet will not."
    },
    {
       "id":122,
       "topic_id":200,
       "title":"View and interpret the routing table of a router.",
       "desc":"Use the show ip route command to view the routing table. Each route will be listed along with the source of the routing information. A C to the left of the route will indicate directly connected routes, and other letters next to the route can also indicate a particular routing protocol that provided the information, such as, for example, R for RIP."
    },
    {
       "id":123,
       "topic_id":200,
       "title":"Differentiate the three types of routing.",
       "desc":"The three types of routing are static (in which routes are manually configured at the CLI), dynamic (in which the routers share routing information via a routing protocol), and default routing (in which a special route is configured for all traffic without a more specific destination network found in the table)."
    },
    {
       "id":124,
       "topic_id":200,
       "title":"Compare and contrast static and dynamic routing.",
       "desc":"Static routing creates no routing update traffic and creates less overhead on the router and network links, but it must be configured manually and does not have the ability to react to link outages. Dynamic routing creates routing update traffic and uses more overhead on the router and network links."
    },
    {
       "id":125,
       "topic_id":200,
       "title":"Configure static routes at the CLI.",
       "desc":"The command syntax to add a route is ip route [destination_network] [mask] [next-hop_address or exitinterface] [administrative_ distance] [permanent]."
    },
    {
       "id":126,
       "topic_id":200,
       "title":"Create a default route.",
       "desc":"To add a default route, use the command syntax ip route 0.0.0.0 0.0.0.0 ip-address or exit interface type and number."
    },
    {
       "id":127,
       "topic_id":200,
       "title":"Understand administrative distance and its role in the selection of the best route.",
       "desc":"Administrative distance (AD) is used to rate the trustworthiness of routing information received on a router from a neighbor router. Administrative distance is an integer from 0 to 255, where 0 is the most trusted and 255 means no traffic will be passed via this route. All routing protocols are assigned a default AD, but it can be changed at the CLI."
    },
    {
       "id":128,
       "topic_id":200,
       "title":"Differentiate distance-vector, link-state, and hybrid routing protocols.",
       "desc":"Distance-vector routing protocols make routing decisions based on hop count (think RIP), while link-state routing protocols are able to consider multiple factors such as bandwidth available and building a topology table. Hybrid routing protocols exhibit characteristics of both types."
    },
    {
       "id":129,
       "topic_id":200,
       "title":"Configure RIPv2 routing.",
       "desc":"To configure RIP routing, first you must be in global configuration mode and then you type the command router rip. Then you add all directly connected networks, making sure to use the classful address and the version 2 command and to disable auto-summarization with the no auto-summary command."
    },
    {
       "id":130,
       "topic_id":200,
       "title":"Compare OSPF and RIPv1.",
       "desc":"OSPF is a link-state protocol that supports VLSM and classless routing; RIPv1 is a distance-vector protocol that does not support VLSM and supports only classful routing."
    },
    {
       "id":131,
       "topic_id":200,
       "title":"Know how OSPF routers become neighbors and/or adjacent.",
       "desc":"OSPF routers become neighbors when each router sees the other\u0027s Hello packets."
    },
    {
       "id":132,
       "topic_id":200,
       "title":"Be able to configure single-area OSPF.",
       "desc":"A minimal single-area configuration involves only two commands: router ospf process-id and network x.x.x.x y.y.y.y area Z."
    },
    {
       "id":133,
       "topic_id":200,
       "title":"Be able to verify the operation of OSPF.",
       "desc":"There are many show commands that provide useful details on OSPF, and it is useful to be completely familiar with the output of each: show ip ospf, show ip ospf database, show ip ospf interface, show ip ospf neighbor, and show ip protocols."
    },
    {
       "id":134,
       "topic_id":200,
       "title":"Remember the three switch functions.",
       "desc":"Address learning, forward/filter decisions, and loop avoidance are the functions of a switch."
    },
    {
       "id":135,
       "topic_id":200,
       "title":"Remember the command show mac address-table.",
       "desc":"The command show mac addresstable will show you the forward/filter table used on the LAN switch."
    },
    {
       "id":136,
       "topic_id":200,
       "title":"Understand the reason for port security.",
       "desc":"Port security restricts access to a switch based on MAC addresses."
    },
    {
       "id":137,
       "topic_id":200,
       "title":"Know the command to enable port security.",
       "desc":"To enable port security on a port, you must first make sure the port is an access port with switchport mode access and then use the switchport port-security command at the interface level. You can set the port security parameters before or after enabling port security."
    },
    {
       "id":138,
       "topic_id":200,
       "title":"Know the commands to verify port security.",
       "desc":"To verify port security, use the show portsecurity, show port-security interface interface, and show running-config commands."
    },
    {
       "id":139,
       "topic_id":200,
       "title":"Understand the term frame tagging.",
       "desc":"Frame tagging refers to VLAN identification; this is what switches use to keep track of all those frames as they\u0027re traversing a switch fabric. It\u0027s how switches identify which frames belong to which VLANs."
    },
    {
       "id":140,
       "topic_id":200,
       "title":"Understand the 802.1q VLAN identification method.",
       "desc":"This is a nonproprietary IEEE method of frame tagging. If you\u0027re trunking between a Cisco switched link and a different brand of switch, you have to use 802.1q for the trunk to work."
    },
    {
       "id":141,
       "topic_id":200,
       "title":"Remember how to set a trunk port on a 2960 switch.",
       "desc":"To set a port to trunking on a 2960, use the switchport mode trunk command."
    },
    {
       "id":142,
       "topic_id":200,
       "title":"Remember to check a switch port\u0027s VLAN assignment when plugging in a new host.",
       "desc":"If you plug a new host into a switch, then you must verify the VLAN membership of that port. If the membership is different than what is needed for that host, the host will not be able to reach the needed network services, such as a workgroup server or printer."
    },
    {
       "id":143,
       "topic_id":200,
       "title":"Remember how to create a Cisco router on a stick to provide inter-VLAN communication.",
       "desc":"You can use a Cisco FastEthernet or Gigabit Ethernet interface to provide inter-VLAN routing. The switch port connected to the router must be a trunk port; then you must create virtual interfaces (subinterfaces) on the router port for each VLAN connecting to it. The hosts in each VLAN will use this subinterface address as their default gateway address"
    },
    {
       "id":144,
       "topic_id":200,
       "title":"Remember how to provide inter-VLAN routing with a layer 3 switch.",
       "desc":"You can use a layer 3 (multilayer) switch to provide IVR just as with a router on a stick, but using a layer 3 switch is more efficient and faster. First you start the routing process with the command ip routing, then create a virtual interface for each VLAN using the command interface vlan vlan, and then apply the IP address for that VLAN under that logical interface."
    },
    {
       "id":145,
       "topic_id":200,
       "title":"Understand the main purpose of the Spanning Tree Protocol in a switched LAN.",
       "desc":"The main purpose of STP is to prevent switching loops in a network with redundant switched paths."
    },
    {
       "id":146,
       "topic_id":200,
       "title":"Remember the states of STP.",
       "desc":"The purpose of the blocking state is to prevent the use of looped paths. A port in listening state prepares to forward data frames without populating the MAC address table. A port in learning state populates the MAC address table but doesn\u0027t forward data frames. A port in forwarding state sends and receives all data frames on the bridged port. Also, a port in the disabled state is virtually nonoperational."
    },
    {
       "id":147,
       "topic_id":200,
       "title":"Remember the command show spanning-tree.",
       "desc":"You must be familiar with the command show spanning-tree and how to determine the root bridge of each VLAN. You can also use the show spanning-tree summary command to help you get a quick glimpse of your STP network and root bridges."
    },
    {
       "id":148,
       "topic_id":200,
       "title":"Understand what PortFast and BPDU Guard provides.",
       "desc":"PortFast allows a port to transition to the forwarding state immediately upon a connection. Because you don\u0027t want other switches connecting to this port, BPDU Guard will shut down a PortFast port if it receives a BPDU."
    },
    {
       "id":149,
       "topic_id":200,
       "title":"Understand what EtherChannel is and how to configure it.",
       "desc":"EtherChannel allows you to bundle links to get more bandwidth instead of allowing STP to shut down redundant ports. You can configure Cisco\u0027s PAgP or the IEEE version, LACP, by creating a port channel interface and assigning the port channel group number to the interfaces you\u0027re bundling."
    },
    {
       "id":150,
       "topic_id":200,
       "title":"Remember the standard and extended IP access-list number ranges.",
       "desc":"The number ranges you can use to configure a standard IP access list are 1–99 and 1300–1999. The number ranges for an extended IP access list are 100–199 and 2000–2699."
    },
    {
       "id":151,
       "topic_id":200,
       "title":"Understand the term implicit deny.",
       "desc":"At the end of every access list is an implicit deny. This means is that if a packet does not match any of the lines in the access list, it will be discarded. Also, if you have nothing but deny statements in your list, the list will not permit any packets."
    },
    {
       "id":152,
       "topic_id":200,
       "title":"Understand the standard IP access-list configuration command.",
       "desc":"To configure a standard IP access list, use the access-list numbers 1–99 or 1300–1999 in global configuration mode. Choose permit or deny, then choose the source IP address you want to filter on using one of the three techniques covered in this chapter."
    },
    {
       "id":153,
       "topic_id":200,
       "title":"Understand the extended IP access-list configuration command.",
       "desc":"To configure an extended IP access list, use the access-list numbers 100–199 or 2000–2699 in global configuration mode. Choose permit or deny, the Network layer protocol field, the source IP address you want to filter on, the destination address you want to filter on, and finally, the Transport layer port number if TCP or UDP has been specified as the protocol."
    },
    {
       "id":154,
       "topic_id":200,
       "title":"Remember the command to verify an access list on a router interface.",
       "desc":"To see whether an access list is set on an interface and in which direction it is filtering, use the show ip interface command. This command will not show you the contents of the access list, merely which access lists are applied on the interface."
    },
    {
       "id":155,
       "topic_id":200,
       "title":"Remember the command to verify the access-list configuration.",
       "desc":"To see the configured access lists on your router, use the show access-list command. This command will not show you which interfaces have an access list set or not."
    },
    {
       "id":156,
       "topic_id":200,
       "title":"Understand the term NAT.",
       "desc":"NAT has a few nicknames. In the industry, it\u0027s referred to as network masquerading, IP-masquerading, and (for those who are besieged with OCD and compelled to spell everything out) Network Address Translation. Whatever you want to dub it, basically, they all refer to the process of rewriting the source/destination addresses of IP packets when they go through a router or firewall. Just focus on the process that\u0027s occurring and your understanding of it—the important part, and you\u0027re golden."
    },
    {
       "id":157,
       "topic_id":200,
       "title":"Remember the three methods of NAT.",
       "desc":"The three methods are static, dynamic, and overloading; the latter is also called PAT."
    },
    {
       "id":158,
       "topic_id":200,
       "title":"Understand static NAT.",
       "desc":"This type of NAT is designed to allow one-to-one mapping between local and global addresses."
    },
    {
       "id":159,
       "topic_id":200,
       "title":"Understand dynamic NAT.",
       "desc":"This version gives you the ability to map a range of unregistered IP addresses to a registered IP address from out of a pool of registered IP addresses."
    },
    {
       "id":160,
       "topic_id":200,
       "title":"Understand overloading.",
       "desc":"Overloading is really a form of dynamic NAT that maps multiple unregistered IP addresses to a single registered IP address (many-to-one) by using different ports. It\u0027s also known as PAT."
    },
    {
       "id":161,
       "topic_id":200,
       "title":"Describe the value of CDP and LLDP",
       "desc":"Cisco Discovery Protocol can be used to help you document and troubleshoot your network. LLDP is a nonproprietary protocol that can provide the same information as CDP."
    },
    {
       "id":162,
       "topic_id":200,
       "title":"Understand the information provided by the output of the show cdp neighbors command.",
       "desc":"The show cdp neighbors command provides the following information: device ID, local interface, holdtime, capability, platform, and port ID (remote interface)."
    },
    {
       "id":163,
       "topic_id":200,
       "title":"List Understand how to configure NTP.",
       "desc":"It\u0027s pretty simple to configure NTP, and you don\u0027t have to remember all of the options! Most important are configuring syslog to mark the time and date and enabling NTP: SF(config)#service timestamps log datetime msec SF(config)#ntp server 172.16.10.1 version 4"
    },
    {
       "id":164,
       "topic_id":200,
       "title":"Understand the various levels of syslog.",
       "desc":"Though it\u0027s simple to configure syslog, there are a bunch of options you have to remember for the exam. Use this mneumonic: \u0022Every Awesome Cisco Engineer Will Need Icecream Daily\u0022 in order to remember this table:"
    },
    {
       "id":165,
       "topic_id":200,
       "title":"Remember the differences between SNMPv2 and SNMPv3",
       "desc":"SNMPv2 uses UDP but can use TCP. SNMPv2 still sends data to the NMS station in clear text, exactly like SNMPv1. SNMPv2 implemented GETBULK and INFORM messages. SNMPv3 uses TCP and authenticates users, plus it can use ACLs in the SNMP strings to protect the NMS station from unauthorized use."
    },
    {
       "id":166,
       "topic_id":200,
       "title":"Describe the advantages of using Secure Shell and list its requirements.",
       "desc":"Secure Shell (SSH) uses encrypted keys to send data so that usernames and passwords are not sent in the clear. It requires that a hostname and domain name be configured for encryption keys to be generated."
    },
    {
       "id":167,
       "topic_id":200,
       "title":"Know which attacks can occur because of TCP/IP\u0027s weakness.",
       "desc":"There are many attacks that can occur because of TCP/IP\u0027s inherent weaknesses. The most important to remember being spoofing, man-in-the-middle and session replaying."
    },
    {
       "id":168,
       "topic_id":200,
       "title":"Understand security program elements.",
       "desc":"The three security program elements are: User Awareness, Training & Physical Security."
    },
    {
       "id":169,
       "topic_id":200,
       "title":"Remember the security password policy elements.",
       "desc":"Password management is important and that goes without saying, but you my set strong password, have expirations, complexity, screen saver passwords, and BIOS passwords."
    },
    {
       "id":170,
       "topic_id":200,
       "title":"Practice setting Cisco passwords.",
       "desc":"On your Cisco devices, practice setting your console, telnet, AUX, and Enable secret passwords as shown in the chapter."
    },
    {
       "id":171,
       "topic_id":200,
       "title":"Understand how to mitigate threats at the access layer.",
       "desc":"You can mitigate threats at the access layer by using port security, DHCP snooping, Dynamic ARP inspection, and identity-based networking."
    },
    {
       "id":172,
       "topic_id":200,
       "title":"Understand TACACS+ and RADIUS.",
       "desc":"TACACS+ is Cisco proprietary, uses TCP, and can separate services. RADIUS is an open standard, uses UDP, and cannot separate services."
    },
    {
       "id":173,
       "topic_id":200,
       "title":"Understand PKI.",
       "desc":"Public Key Infrastructure (PKI) is a system that links users to public keys and verifies a user\u0027s identity by using a certificate authority (CA)."
    },
    {
       "id":174,
       "topic_id":200,
       "title":"Understand Kerberos.",
       "desc":"Kerberos, created at MIT, isn\u0027t just a protocol; it\u0027s an entire security system that establishes a user\u0027s identity when they first log on to a system that\u0027s running it."
    },
    {
       "id":175,
       "topic_id":200,
       "title":"Understand FHRP\u0027s, especially HSRP.",
       "desc":"The FHRPs are HSRP, VRRP and GLBP, with HSRP and GLBP being Cisco proprietary."
    },
    {
       "id":176,
       "topic_id":200,
       "title":"Remember the HSRP Virtual address",
       "desc":"The HSRP MAC address has only one variable piece in it. The first 24 bits still identify the vendor who manufactured the device (the organizationally unique identifier, or OUI). The next 16 bits in the address tell us that the MAC address is a well-known HSRP MAC address. Finally, the last 8 bits of the address are the hexadecimal representation of the HSRP group number."
    },
    {
       "id":177,
       "topic_id":200,
       "title":"Understand the term virtual private network.",
       "desc":"You must understand why and how to use a VPN between two sites and the purpose that IPsec serves with VPNs."
    },
    {
       "id":178,
       "topic_id":200,
       "title":"Understand how to configure and verify a GRE tunnel.",
       "desc":"To configure GRE, first configure the logical tunnel with the interface tunnel number command. Configure the mode and transport, if needed, with the tunnel mode mode protocol command, then configure the IP addresses on the tunnel interfaces, the tunnel source and tunnel destination addresses, and your physical interfaces with global addresses. Verify with the show interface tunnel command as well as the ping protocol."
    },
    {
       "id":179,
       "topic_id":200,
       "title":"Have a deep understanding of QoS.",
       "desc":"You must understand QoS, specifically marking, device trust, and prioritization for voice, video, and data. Also in the need to know category: shaping, policing, and congestion management. Understand all of these in detail."
    },
    {
       "id":180,
       "topic_id":200,
       "title":"Remember the two queuing mechanisms used in today\u0027s networks.",
       "desc":"The two queuing mechanisms you should now use in today\u0027s network are CBWFQ (class based weighted fair queuing) and LLQ (low latency queuing)."
    },
    {
       "id":181,
       "topic_id":200,
       "title":"Remember the two tools that identify and respond to traffic problems.",
       "desc":"Policers and shapers are two tools that identify and respond to traffic problems and are both rate-limiters."
    },
    {
       "id":182,
       "topic_id":200,
       "title":"Understand why we need IPv6.",
       "desc":"Without IPv6, the world would be depleted of IP addresses."
    },
    {
       "id":183,
       "topic_id":200,
       "title":"Understand link-local.",
       "desc":"Link-local is like an IPv4 APIPA IP address, and it can\u0027t be routed at all, not even in your organization."
    },
    {
       "id":184,
       "topic_id":200,
       "title":"Understand unique local.",
       "desc":"This, like link-local, is like a private IP address in IPv4 and cannot be routed to the Internet. However, the difference between link-local and unique local is that unique local can be routed within your organization or company."
    },
    {
       "id":185,
       "topic_id":200,
       "title":"Remember IPv6 addressing.",
       "desc":"IPv6 addressing is not like IPv4 addressing. IPv6 addressing has much more address space, is 128 bits long, and represented in hexadecimal, unlike IPv4, which is only 32 bits long and represented in decimal."
    },
    {
       "id":186,
       "topic_id":200,
       "title":"Understand and be able to read a EUI-64 address with the 7th bit inverted.",
       "desc":"Hosts can use autoconfiguration to obtain an IPv6 address, and one of the ways it can do that is through what is called EUI-64. This takes the unique MAC address of a host and inserts FF:FE in the middle of the address to change a 48-bit MAC address to a 64-bit interface ID. In addition to inserting the 16 bits into the interface ID, the 7th bit of the 1st byte is inverted, typically from a 0 to a 1."
    },
    {
       "id":187,
       "topic_id":200,
       "title":"Understand how to Verify IP parameters for Client OS (Windows, Mac OS, Linux)",
       "desc":"To configure and verify the various OS\u0027s, use tools such as ipconfig, ipconfig /all, and ifconfig"
    },
    {
       "id":188,
       "topic_id":200,
       "title":"Remember the Cisco steps in troubleshooting an IPv4 and IPv6 network.",
       "desc":"1. Check the cables to find out if there\u0027s a faulty cable or interface in the mix and verify the interface\u0027s statistics.  2. Make sure that devices are determining the correct path from the source to the destination. Manipulate the routing information if needed.  3. Verify that the default gateway is correct. 4. Verify that name resolution settings are correct.  5. Verify that there are no ACLs blocking traffic."
    },
    {
       "id":189,
       "topic_id":200,
       "title":"Remember the commands to verify and troubleshoot IPv4 and IPv6.",
       "desc":"You need to remember and practice the commands used in this chapter, especially ping and traceroute (tracert on Windows). We also used the Windows commands ipconfig. route print and netsh, as well as Cisco\u0027s commands show ip int brief, show interface, and show route."
    },
    {
       "id":190,
       "topic_id":200,
       "title":"Remember how to verify an ARP cache with IPv6.",
       "desc":"The command show ipv6 neighbors shows the IP-to-MAC-address resolution table on a Cisco router."
    },
    {
       "id":191,
       "topic_id":200,
       "title":"Remember to look at the statistics on a router and switch interface to determine problems.",
       "desc":"You\u0027ve got to be able to analyze interface statistics to spot problems if they exist, including speed and duplex settings, input queue drops, output queue drops, and input and output errors."
    },
    {
       "id":192,
       "topic_id":200,
       "title":"Understand what a native VLAN is and how to change it.",
       "desc":"A native VLAN works with only 802.1q trunks and allows untagged traffic to traverse the trunk link. This is VLAN 1 by default on all Cisco switches, but it can be changed for security reasons with the switchport native vlan vlan command."
    },
    {
       "id":193,
       "topic_id":200,
       "title":"Understand the IEEE 802.11a specification.",
       "desc":"802.11a runs in the 5GHz spectrum, and if you use the 802.11h extensions, you have 23 non-overlapping channels. 802.11a can run up to 54Mbps, but only if you are less than 50 feet from an access point."
    },
    {
       "id":194,
       "topic_id":200,
       "title":"Understand the IEEE 802.11b specification.",
       "desc":"IEEE 802.11b runs in the 2.4GHz range and has three non-overlapping channels. It can handle long distances, but with a maximum data rate of up to 11Mpbs."
    },
    {
       "id":195,
       "topic_id":200,
       "title":"Understand the IEEE 802.11g specification.",
       "desc":"IEEE 802.11g is 802.11b\u0027s big brother and runs in the same 2.4GHz range, but it has a higher data rate of 54Mbps if you are less than 100 feet from an access point."
    },
    {
       "id":196,
       "topic_id":200,
       "title":"Understand the IEEE 802.11n components.",
       "desc":"802.11n uses 40Mhz wide channels to provide more bandwidth, provides MAC efficiency with block acknowledgements, and uses MIMO to allow better throughput and distance at high speeds."
    },
    {
       "id":197,
       "topic_id":200,
       "title":"Understand the difference between WPA, WPA2 and WPA3",
       "desc":"802.11n uses 40."
    },
    {
       "id":198,
       "topic_id":200,
       "title":"Endpoints",
       "desc":"Endpoints are just the things we connect into the network, including desktops, laptops, IP phones, access points, and IoT devices."
    },
    {
       "id":199,
       "topic_id":200,
       "title":"Server",
       "desc":"Servers provide services to the users and devices on your network. There are several forms of these available: Flat servers, which are typically 1 RU sized rack mounted servers and tower servers that\nare basically just desktops with more resources inside. And then there are blade servers\nthat connect to a big chassis. There are also many types of server roles available including\nDHCP, Web, Database, and Active Directory."
    },
    {
       "id":200,
       "topic_id":200,
       "title":"Verify IP address on Windows, Mac, and Linux",
       "desc":"You can spend the better part of your day-to-day activities either setting IP addresses on interfaces or verifying settings are correct on a device. Because of that, and also because of exam topics, I walked you through how to check the IP on Windows, Macs, and Linux desktops."
    },
    {
       "id":201,
       "topic_id":200,
       "title":"WLAN Deployment Models",
       "desc":"Cisco uses three types of WLAN deployment models. Standalone, where the access point acts independently and must be manually configured and lightweight, where the access point registers to a controller via an encrypted CAPWAP tunnel that allows for central management and easier performance tuning. The last model we discussed is the cloud method, where the controller lives in the cloud and APs simply need to get online to be managed. Meraki is Cisco\u0027s cloud-based networking solution."
    },
    {
       "id":202,
       "topic_id":200,
       "title":"WLC Port Types",
       "desc":"The WLC has several port types such as console ports for initial configuration: service ports for out of band management, a redundancy port to allow for high availability and distributed system ports, which is just a fancy name for regular interfaces."
    },
    {
       "id":203,
       "topic_id":200,
       "title":"WLC Interface Types",
       "desc":"The WLC also has several interface types that provide services to the WLANs and other features. The service port interface provides access to the service port and the redundancy management port provides access to the redundancy port. The management port is used provide access to WLC. It runs the AP-Manager by default, which allows APs to register to the interface and terminates CAPWAP tunnels. Lastly, dynamic interfaces can be used to terminate WLANs to specific VLANs."
    },
    {
       "id":204,
       "topic_id":200,
       "title":"WLC and AP Management Access Connections",
       "desc":"Cisco Wireless controllers and access points support several methods for providing management access including telnet: SSH, HTTP, HTTPS, a console port, RADIUS, and TACACS+. CDP is also very useful for managing these systems."
    },
    {
       "id":205,
       "topic_id":200,
       "title":"Joining APs",
       "desc":"Wireless controllers require APs in order to provide network access. There are three methods for joining APs that we covered in the chapter: The manual method, where you log into the AP and type some commands, and the DNS method where you make a DNS A record to allow the AP to find the wireless controller on its own. Finally, there\u0027s also the DHCP method where we use our hex skills to provide the WLC address through option 43."
    },
    {
       "id":206,
       "topic_id":200,
       "title":"Configuring WLANs",
       "desc":"A large part of the WLC configuration is creating the WLANs that clients can connect to. There are several parts to this including the SSID, security method, and myriad other options we can choose to enable when creating a wireless network."
    },
    {
       "id":207,
       "topic_id":200,
       "title":"Virtualization",
       "desc":"Virtualization is a technology that allows a server to host multiple other computers as virtual machines. It does this by abstracting the host resources and sharing them with the guest machines. Virtualization provides several useful features such as the ability to clone a virtual machine in order to rapidly create new VMs."
    },
    {
       "id":208,
       "topic_id":200,
       "title":"RESTful API",
       "desc":"A RESTful API uses common HTTP requests to GET, PUT, POST, and DELETE data from a server or device. Since HTTP is supported everywhere, it is easy to use restful APIs in practically all automation solutions."
    },
    {
       "id":209,
       "topic_id":200,
       "title":"JSON",
       "desc":"JavaScript Object Notation (JSON) is a data exchange format that presents data in a human-readable format and is widely supported by most systems. Data is represented in key/value pairs; information can also be nested as required."
    },
    {
       "id":210,
       "topic_id":200,
       "title":"SDN Architecture",
       "desc":"Software Defined Networking (SDN) solutions tunnel traffic across the underlay devices using an overlay. The underlay provides connectivity for the tunnels to be able to be formed. The overlay provides the actual services to the fabric. The fabric is simply a term for all network devices that use the SDN solution."
    },
    {
       "id":211,
       "topic_id":200,
       "title":"Controller-based Architecture",
       "desc":"Rather than managing your network devices individually, you can use a controller-based solution that allows you to centrally manage everything instead. This improves efficiency since you can configure a large number of devices at once and also reduces the risk of configuration errors because your changes aren\u0027t applied immediately and can be reviewed. It also ensures configuration for all your network devices is consistent. Controllers also provide a great single point to monitor or script against since it knows about most or all of your network fabric. SDN Controllers communicate with the network using a southbound interface towards the devices and a northbound interface to permit access to the SDN Controller."
    },
    {
       "id":212,
       "topic_id":200,
       "title":"DNA Center",
       "desc":"DNA Center is the successor to APIC-EM and provides SDN and controllerbased features to your network. DNA Center can ensure your configuration is consistent and make sure QoS is working properly and is set up on all devices in the network. The assurance feature provides a unique time machine to view issues that happened up to a week ago."
    },
    {
       "id":213,
       "topic_id":200,
       "title":"Ansible",
       "desc":"Ansible is a Python-based configuration management tool that uses YAML playbooks to push configuration to nodes. It\u0027s an agentless solution offering wide support for network devices because it uses SSH to reach nodes. Because there\u0027s no agent, Ansible can only push configuration to nodes."
    },
    {
       "id":214,
       "topic_id":200,
       "title":"Puppet",
       "desc":"Puppet is a Ruby-based configuration management tool that uses custom manifest files to configure devices. It requires an agent to be installed on the node, so it has less network support. Puppet also doesn\u0027t support pushing configuration to nodes. Instead, the configuration is applied when the agent checks in. Puppet does support Cisco network devices that can install the Puppet agent."
    },
    {
       "id":215,
       "topic_id":200,
       "title":"Chef",
       "desc":"Chef is a Ruby-based configuration tool that uses cookbooks to apply configuration. Chef is the most advanced solution in this chapter and is better suited for programmers because it\u0027s more structured and has a strong developer focus. It also requires that nodes have an agent deployed for it to be able to manage them. Chef can\u0027t push configurations."
    }
  ]